import { useMsal } from '@azure/msal-react'
import { Button, Tooltip } from '@fluentui/react-components'
import { PersonRegular } from '@fluentui/react-icons'
import styles from './ProjectEconomyButton.module.css'
import { IPublicClientApplication } from '@azure/msal-browser'

const handleLogout = (instance: IPublicClientApplication) => {
  instance.logoutRedirect().catch((e: Error) => {
    console.error(e)
  })
}

export const SignOutButton = () => {
  const { instance } = useMsal()

  return (
    <Tooltip content="Logga ut" relationship="label">
      <Button
        data-testid="SignOutButton"
        className={styles.projectEconomyButton}
        icon={<PersonRegular />}
        appearance="subtle"
        onClick={() => handleLogout(instance)}
      />
    </Tooltip>
  )
}
